import api from "./httpClient";

export function lockDatabase() {
	return api.patch("/Config/Lock");
}

export function unlockDatabase() {
	return api.patch("/Config/Unlock");
}

export function getConfig() {
  return api.get("/Config");
}
